// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2smWp","content":"styles_content__3nsP-","checkbox":"styles_checkbox__2y-uk","checkboxLabel":"styles_checkboxLabel__S3aAm"};